import { render } from "./CadastroGrupos.vue?vue&type=template&id=91f75de0&scoped=true"
import script from "./CadastroGrupos.vue?vue&type=script&lang=js"
export * from "./CadastroGrupos.vue?vue&type=script&lang=js"

import "./CadastroGrupos.vue?vue&type=style&index=0&id=91f75de0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91f75de0"]])

export default __exports__